import cloneDeep from 'lodash-es/cloneDeep';
import merge from 'lodash-es/merge';

const switchVariant = {
    tab: {
        boxSizing: 'border-box',
        border: '2px solid',
        borderColor: 'slt-black.200',
        borderRadius: 20,
        height: '34px',
        width: '162px',
        bg: 'slt-black.50',
        textStyle: 'slt-body-text-x1',
        fontWeight: 500,
        fontSize: '1.125rem',
        marginTop: 1,
        paddingTop: 1,
        paddingBottom: 1,
        _selected: {
            boxSizing: 'border-box',
            height: '42px',
            bg: 'white',
            border: '4px solid',
            borderColor: 'rgba(179, 179, 179, 0.4)',
            boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.25)',
            marginTop: 0,
            paddingTop: 1,
            paddingBottom: 1,
            zIndex: 2,
            fontWeight: '600',
        },
        _disabled: {
            fontWeight: 400,
            textColor: 'slt-black.600',
            border: '0px',
        },
    },
};

const pillVariant = {
    root: {
        borderRadius: 20,
        background: 'slt-black.50',
        outline: '2px solid',
        outlineColor: 'slt-black.200',
        outlineOffset: '-2px',
    },
    tab: {
        textStyle: 'slt-body-text-lg',
        fontSize: '1.125rem',
        fontWeight: 500,
        borderRadius: 20,
        background: 'slt-black.50',
        paddingY: 1,
        paddingX: 8,
        _selected: {
            background: 'white',
            outline: '4px solid',
            outlineColor: 'rgba(179, 179, 179, 0.4)',
            outlineOffset: '0px',
            boxShadow: '0px 0px 10px 4px rgba(0, 0, 0, 0.25)',
            zIndex: 2,
        },
        _disabled: {
            fontWeight: 400,
            textColor: 'slt-black.600',
            borderColor: 'slt-black.50',
        },
    },
};

const regularVariant = {
    root: {
        width: '100%',
    },
    tablist: {
        gap: 4,
        justifyContent: 'center',
    },
    tab: {
        textStyle: 'slt-body-text-lg',
        fontSize: '1.125rem',
        background: 'white',
        margin: 0,
        paddingX: 0,
        paddingTop: 0,
        paddingBottom: 1,
        _selected: {
            fontWeight: 700,
            borderBottom: '4px solid',
            marginBottom: '-4px',
            borderColor: 'slt-black.900',
        },
        _disabled: {
            textColor: 'slt-black.400',
        },
        _focus: {
            boxShadow: 'unset',
        },
    },
    tabpanel: {
        padding: 0,
        marginTop: 4,
    },
};

const turnToVariant = {
    ...regularVariant,
    tab: {
        ...regularVariant.tab,
        _selected: {
            ...regularVariant.tab._selected,
            fontWeight: 600,
        },
    },
};

const buttonVariant = {
    tab: {
        button: {
            textStyle: 'slt-body-text-lg',
            fontWeight: 700,
            textTransform: 'none',
            border: '1px solid',
        },
        background: 'white',
        margin: 0,
        padding: 0,
        _disabled: {
            button: {
                pointerEvents: 'none',
                opacity: 0.35,
            },
        },
        _focus: {
            boxShadow: 'unset',
        },
    },
};

const buttonWithUnderlineVariant = merge(cloneDeep(buttonVariant), {
    tab: {
        _selected: {
            paddingBottom: 1,
            borderBottom: '4px solid',
            borderColor: 'slt-black.900',
        },
    },
});

const enclosedVariant = {
    root: {
        width: '100%',
    },
    tab: {
        textStyle: { base: 'body-small', md: 'body-base' },
        fontSize: '0.875rem',
        fontWeight: 500,
        gap: 1,
        borderRadius: '4px 4px 0px 0px',
        borderTop: '1px solid',
        borderRight: '1px solid',
        borderLeft: '1px solid',
        borderColor: 'slt-beige.400',
        marginBottom: '-1px',
        _selected: {
            background: 'white',
            borderColor: 'slt-pepper.100',
            zIndex: 1,
        },
        color: 'slt-pepper.1000',
    },
    tablist: {
        background: 'slt-beige.400',
        borderBottom: '1px solid',
        borderColor: 'slt-pepper.100',
        marginBottom: '-1px',
        paddingX: { base: 2, sm: 8, lg: 10, xl: 16 },
    },
    tabpanel: {
        display: 'flex',
        textStyle: 'body-base',
        paddingY: 4,
        paddingX: { base: 4, sm: 8, md: 0 },
    },
};

export const Tabs = {
    variants: {
        switch: switchVariant,
        'slt-pill': pillVariant,
        'slt-regular': regularVariant,
        'slt-button': buttonVariant,
        'slt-button-underline': buttonWithUnderlineVariant,
        'slt-turn-to': turnToVariant,
        'slt-enclosed': enclosedVariant,
    },
    defaultProps: {
        variant: 'slt-regular',
    },
};
